(function () {
  function initGallery(root) {
    if (!root || root.dataset.caReady === 'true') return;
    root.dataset.caReady = 'true';
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ca-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ca-gallery-thumb]'));
    var counter = root.querySelector('[data-ca-gallery-counter]');
    var current = 0;
    var zoomLayer = null;

    function closeZoom() {
      if (!zoomLayer) return;
      zoomLayer.remove();
      zoomLayer = null;
    }

    function openZoom(image) {
      closeZoom();
      zoomLayer = document.createElement('div');
      zoomLayer.className = 'ca-product-media-gallery__zoom';
      zoomLayer.setAttribute('role', 'dialog');
      zoomLayer.setAttribute('aria-modal', 'true');
      zoomLayer.innerHTML = '<button type="button" class="ca-product-media-gallery__zoom-close" data-ca-gallery-zoom-close aria-label="Cerrar zoom">×</button><img src="' + image.src + '" alt="' + image.alt.replace(/"/g, '&quot;') + '">';
      document.body.appendChild(zoomLayer);
      zoomLayer.addEventListener('click', function (event) {
        if (event.target === zoomLayer || event.target.closest('[data-ca-gallery-zoom-close]')) closeZoom();
      });
      zoomLayer.querySelector('[data-ca-gallery-zoom-close]').focus();
    }

    function go(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === current); });
      thumbs.forEach(function (thumb, i) {
        var active = i === current;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (counter) counter.textContent = (current + 1) + ' / ' + slides.length;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { go(Number(thumb.dataset.caGalleryThumb)); });
    });
    slides.forEach(function (slide) {
      var image = slide.querySelector('img');
      if (!image) return;
      image.addEventListener('click', function () {
        if (window.matchMedia('(min-width: 750px)').matches) openZoom(image);
      });
      image.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          if (window.matchMedia('(min-width: 750px)').matches) openZoom(image);
        }
      });
    });
    var previous = root.querySelector('[data-ca-gallery-prev]');
    var next = root.querySelector('[data-ca-gallery-next]');
    if (previous) previous.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    var viewport = root.querySelector('[data-ca-gallery-viewport]');
    var touchStartX = 0;
    var touchStartY = 0;
    if (viewport) {
      viewport.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      }, { passive: true });
      viewport.addEventListener('touchend', function (event) {
        if (!event.changedTouches.length) return;
        var deltaX = event.changedTouches[0].clientX - touchStartX;
        var deltaY = event.changedTouches[0].clientY - touchStartY;
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        go(deltaX < 0 ? current + 1 : current - 1);
      }, { passive: true });
    }
    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') go(current - 1);
      if (event.key === 'ArrowRight') go(current + 1);
      if (event.key === 'Escape') closeZoom();
    });
    go(0);
  }

  function init() { document.querySelectorAll('[data-ca-product-gallery]').forEach(initGallery); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
